import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import Editor from '../Editor/Editor';
import { renderError } from '../../tools/validation';

const propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.string,
};

const defaultProps = {
  label: null,
  disabled: false,
  rows: 3,
};

const TextareaField = ({
  input: { value, onChange },
  label,
  meta: { touched, error },
}) => (
  <div className="c-bb-form__input o-content">
    {label && <label htmlFor="title">{label}</label>}
    <div className="c-bb-form__textarea c-text c-bb-form__textarea_with-resize">
      <Editor
        content={value}
        onChange={onChange}
        shouldBroadCastUpdate={false}
      />
    </div>
    {touched && error &&
    <span className="c-bb-form__input-error">{renderError(error)}</span>}
  </div>
);

TextareaField.propTypes = propTypes;
TextareaField.defaultProps = defaultProps;

export default withNamespaces()(TextareaField);



// WEBPACK FOOTER //
// ./src/components/FormElements/TextareaField.js